export class EventNames {
  static PageView: string = 'pageview';

  static ProductImpression: string = 'productimpression';

  static ProductClick: string = 'productclick';

  static ProductPageView: string = 'productpageview';

  static BannerImpression = 'bannerimpression';

  static BannerClick = 'bannerclick';

  static ElementImpression = 'elementimpression';

  static ElementClick = 'elementclick';

  static AddToCart: string = 'addtocart';

  static RemoveFromCart: string = 'removefromcart';

  static QuantityChanged: string = 'quantitychanged';

  static StartedCheckout: string = 'startedcheckout';

  static CompletedCheckout: string = 'completedcheckout';

  static SearchPerformed: string = 'searchperformed';

  static ContinueToPayment: string = 'continuetopayment';

  static SessionStarted: string = 'sessionstarted';

  static LoggedIn: string = 'loggedin';

  static LoggedOut: string = 'loggedout';
}
